import { render, staticRenderFns } from "./create.1.vue?vue&type=template&id=55dfd468&"
import script from "./create.1.vue?vue&type=script&lang=js&"
export * from "./create.1.vue?vue&type=script&lang=js&"
import style0 from "./create.1.vue?vue&type=style&index=0&id=55dfd468&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports